// extracted by mini-css-extract-plugin
export var backgroundImage = "standard-module--backgroundImage--afffa";
export var heroContent = "standard-module--heroContent--a7c35";
export var heroContentWrapper = "standard-module--heroContentWrapper--40529";
export var heroStandardPage = "standard-module--heroStandardPage--a97b6";
export var subtitle = "standard-module--subtitle--fae54";
export var title = "standard-module--title--92df2";